// import React, { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

// import "../assets/css/GroupCenter.css";

// const GroupCreate = () => {
//   const dispatch = useDispatch();
//   const { profile, loading: profileLoading, error } = useSelector(
//     (state) => state.userProfile
//   );

//   const [formData, setFormData] = useState({
//     name: "",
//     group_type: "JLG",
//     centreId: "",
//   });
//   const [showForm, setShowForm] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [groups, setGroups] = useState([]);
//   const [centres, setCentres] = useState([]);

//   // Fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//   const fetchCenters = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/get-centre?branchId=${profile.id}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );
//       setCentres(res.data.centres || []);
//     } catch (err) {
//       console.error("Error fetching centres:", err);
//     }
//   };

//   const fetchGroups = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/get-group?branch_id=${profile.id}}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       console.log("Groups API Response:", res.data);
//       // Handle API structures: { groups: [...] } OR { data: [...] } OR [...]
//       setGroups(res.data.groups || res.data.data || res.data || []);
//     } catch (err) {
//       console.error("Error fetching groups:", err);
//     }
//   };

//   fetchGroups();   // ✅ Always fetch groups
//   if (profile) {
//     fetchCenters(); // ✅ only need profile for centres
//   }
// }, [profile]);

//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (!profile?.id || !profile?.branchId) {
//         alert("Profile incomplete! Please login again.");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         name: formData.name,
//         group_type: formData.group_type,
//         branch_id: profile.id, // ✅ FIXED
//         // centre_id: formData.centreId, // ✅ snake_case
//         created_by: profile.id,
//       };

//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/create-group`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       alert("Group Created Successfully!");
//       setGroups((prev) => [...prev, res.data.group || payload]);

//       setShowForm(false);
//       setFormData({ name: "", group_type: "JLG", centreId: "" });
//     } catch (error) {
//       console.error("Error creating group:", error);
//       alert(error.response?.data?.message || "Failed to create group");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (profileLoading) return <p>Loading profile...</p>;
//   if (error) return <p className="text-red-500">Error: {error}</p>;

//   return (
//     <div className="group-group-2-container">
//       <div className="group-group-2-header-row">
//         <h2>
//           <i className="bi bi-people-fill"></i> Groups
//         </h2>
//         <button
//           className="group-group-2-create-btn"
//           onClick={() => setShowForm(true)}
//         >
//           Add Group
//         </button>
//       </div>

//       {showForm && (
//         <div className="group-group-2-modal-overlay">
//           <div className="group-group-2-modal-form">
//             <button
//               className="group-group-2-close-btn"
//               onClick={() => setShowForm(false)}
//             >
//               X
//             </button>
//             <form onSubmit={handleSubmit}>
//               {/* Group Name */}
//               <div className="group-group-2-input-box">
//                 <label>Group Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               {/* Group Type */}
//               <div className="group-group-2-input-box">
//                 <label>Group Type</label>
//                 <select
//                   name="group_type"
//                   value={formData.group_type}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="JLG">JLG</option>
//                   <option value="SHG">SHG</option>
//                   <option value="Other">Other</option>
//                 </select>
//               </div>

//               {/* Centre Selection */}
//               <div className="group-group-2-input-box">
//                 <label>Centre</label>
//                 <select
//                   name="centreId"
//                   value={formData.centreId}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="">-- Select Centre --</option>
//                   {centres.map((c) => (
//                     <option key={c.id} value={c.id}>
//                       {c.name} ({c.location})
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <p className="text-sm text-gray-500">
//                 BranchId: {profile?.branchId || "N/A"} | UserId:{" "}
//                 {profile?.id || "N/A"}
//               </p>

//               <button
//                 type="submit"
//                 className="group-group-2-submit-btn"
//                 disabled={loading}
//               >
//                 {loading ? "Saving..." : "Submit"}
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       <h3 className="group-group-2-section-title">Group List</h3>
//       <div className="group-group-2-card-grid">

//         {groups.map((g) => (
//           <div
//             className="group-group-2-group-card"
//             key={g.id || Math.random()} // ✅ FIXED key warning
//           >
//             <p>
//               <strong>Group Name: </strong> {g.name}
//             </p>
//             <p>
//               <strong>Type: </strong> {g.group_type}
//             </p>

//              <p>
//       {/* <strong>Centre: </strong>{""}
//       {centres.find((c) => c.id === g.branch_id)?.name || "N/A"} */}
//     </p>

//             {g.createdAt && (
//               <p>
//                 <strong>Created:</strong>{" "}
//                 {new Date(g.createdAt).toLocaleString()}
//               </p>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GroupCreate;

// import React, { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
// import "../assets/css/GroupCreate.css";

// const GroupCreate = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     groupType: "JLG",
//     centerId: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [groups, setGroups] = useState([]);
//   const [centers, setCenters] = useState([]);
//   const dispatch = useDispatch();
//   const {
//     profile,
//     loading: profileLoading,
//     error,
//   } = useSelector((state) => state.userProfile);

//   // 🔍 Search + Pagination
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   // Fetch profile
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   useEffect(() => {
//     const fetchCenters = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/get-centre?branchId=${profile.id}`,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//             },
//           }
//         );
//         // console.log("center data:",res.data)
//         setCenters(res.data.centres || []);
//         // console.log("centers",centers)
//       } catch (err) {
//         console.error("Error fetching centres:", err);
//       }
//     };

//     const fetchGroups = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_URL}/get-group?branch_id=${profile.id}}`,
//           {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//             },
//           }
//         );

//         // console.log("Groups API Response:", res.data);
//         // Handle API structures: { groups: [...] } OR { data: [...] } OR [...]
//         setGroups(res.data.groups || res.data.data || res.data || []);
//       } catch (err) {
//         console.error("Error fetching groups:", err);
//       }
//     };

//     fetchGroups(); // ✅ Always fetch groups
//     if (profile) {
//       fetchCenters(); // ✅ only need profile for centres
//     }
//   }, [profile]);

//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (!profile?.id || !profile?.branchId) {
//         alert("Profile incomplete! Please login again.");
//         setLoading(false);
//         return;
//       }

//       const payload = {
//         name: formData.name,
//         groupType: formData.groupType,
//         branch_id: profile.id, // ✅ FIXED
//         // centre_id: formData.centreId, // ✅ snake_case
//         created_by: profile.id,
//       };

//       const res = await axios.post(
//         `${process.env.REACT_APP_API_URL}/create-group`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       alert("Group Created Successfully!");
//       setGroups((prev) => [...prev, res.data.group || payload]);
//       setFormData({ name: "", groupType: "JLG", centreId: "" });
//     } catch (error) {
//       console.error("Error creating group:", error);
//       alert(error.response?.data?.message || "Failed to create group");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // search and filter logic
//   const filteredData = useMemo(() => {
//     let data = [...groups];

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     return data;
//   }, [searchQuery, groups]);

//   // pagination
//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);

//   const paginatedData = filteredData.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   if (profileLoading) return <p>Loading profile...</p>;
//   if (error) return <p className="text-red-500">Error: {error}</p>;

//   return (
//     <div className="group-container">
//       <h1 className="group-heading">Groups</h1>

//       {/* Group Member Creation section */}
//       <div className="group-create-container">
//         <h2>Create Group</h2>
//         <form className="group-create-form" onSubmit={handleSubmit}>
//           <div className="group-create-form-inputs">
//             <div className="group-create-form-group">
//               <label htmlFor="">Group Name</label>
//               <br />
//               <input
//                 type="text"
//                 value={formData.centerName}
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="group-create-form-group">
//               <label htmlFor="">Group Type</label>
//               <br />
//               <select name="groupType">
//                 <option value="JLG">JLG</option>
//                 <option value="SHG">SHG</option>
//                 <option value="Other">Other</option>
//               </select>
//             </div>
//             <div className="group-create-form-group">
//               <label>Centre</label>
//               <select
//                 name="centerId"
//                 value={formData.centerId}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Select Centre</option>
//                 {centers.map((c) => (
//                   <option key={c.id} value={c.id}>
//                     {c.name} ({c.location})
//                   </option>
//                 ))}
//               </select>
//             </div>
//             {/* <div className="group-create-form-group">
//               <label htmlFor="">Center Name</label><br />
//               <input type="text" />
//             </div> */}
//           </div>
//           <div className="branch-details">
//             <p>
//               Branch Id: <span>{profile?.branchId || "N/A"}</span>
//             </p>
//             <p>
//               User Id: <span>{profile?.id || "N/A"}</span>
//             </p>
//           </div>
//           <button>Add Group</button>
//         </form>
//       </div>

//       {/* Group member report section */}
//       <div className="group-report-container">
//         <h2>Group Report</h2>
//         <div className="group-report-filter">
//           <input
//             type="text"
//             placeholder="Search by any field..."
//             value={searchQuery}
//             onChange={(e) => {
//               setSearchQuery(e.target.value);
//               setCurrentPage(1);
//             }}
//           />

//           <label>
//             Show{" "}
//             <select
//               value={rowsPerPage}
//               onChange={(e) => {
//                 setRowsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value={100}>100</option>
//             </select>{" "}
//             entries
//           </label>
//         </div>

//         {/* Table */}
//         <div className="group-report-section">
//           <table className="group-report-table">
//             <thead>
//               <tr>
//                 <th>S.No.</th>
//                 <th>Group Name</th>
//                 <th>Group Type</th>
//                 <th>Center</th>
//                 <th>User Id</th>
//                 {/* <th>User Id</th> */}
//                 <th>Created At</th>
//                 {/* <th>CGT Taken By</th>
//                 <th>Action</th> */}
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item, index) => (
//                   <tr key={index}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.name}</td>
//                     <td>{item.group_type}</td>
//                     <td>
//                       {centers.find((c) => c.branchId === item.branch_id)
//                         ?.name || "N/A"}
//                     </td>
//                     <td>{item.created_by}</td>
//                     {/* <td>{item.id}</td> */}
//                     <td>{new Date(item.createdAt).toLocaleString("en-IN")}</td>
//                     {/* <td className="group-report-btns">
//                       <button
//                         className="group-report-edit-btn"
//                         // onClick={() => {
//                         //   setIsModalOpen(true);
//                         //   setSelectedCustomer(row);
//                         // }}
//                         title="Edit" // tooltip on hover
//                       >
//                         <Edit />
//                       </button>

//                       <button
//                         className="group-report-delete-btn"
//                         // onClick={() => openDeleteDialog(row.id)}
//                         title="Delete"
//                       >
//                         <Trash />
//                       </button>
//                     </td> */}
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="10" className="group-report-table-no-records">
//                     ✅ No records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Pagination */}
//       <div className="group-report-pagination-btns">
//         <button
//           onClick={() => setCurrentPage((p) => p - 1)}
//           disabled={currentPage === 1}
//         >
//           ⬅ Previous
//         </button>

//         <span>
//           Page {currentPage} of {totalPages || 1}
//         </span>

//         <button
//           onClick={() => setCurrentPage((p) => p + 1)}
//           disabled={currentPage === totalPages || totalPages === 0}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// export default GroupCreate;


import React, { useEffect, useMemo, useState } from "react";
import "../assets/css/GroupCreate.css";
import { Edit, Trash } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const GroupCreate = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const ITEMS_PER_PAGE_OPTIONS = [5, 10, 20];

  const [modalOpen, setModalOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  // Store only centerId here
  const [selectCenterId, setSelectedCenterId] = useState(0);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  console.log("profile",profile)

  const [groups, setGroups] = useState([]);
  const [center, setCenter] = useState([]);

  const [formData, setFormData] = useState({
    groupName: "",
    minMember: "",
    maxMember: "",
    status: "Active",
  });

  // Input Handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Reset Form
  const resetForm = () => {
    setFormData({
      groupName: "",
      minMember: "",
      maxMember: "",
      status: "Active",
    });
    setSelectedCenterId(0);
    setEditIndex(null);
  };

  /* ------------------------------------
      CREATE + UPDATE FUNCTION 
  ------------------------------------ */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.groupName || !formData.minMember || !formData.maxMember) {
      toast.warn("Please fill required fields");
      return;
    }

    if (!selectCenterId) {
      toast.warn("Please select a Center");
      return;
    }

    const payload = {
      branchId: Number(profile.branchId),
      groupname: formData.groupName,
      LoanofficerId: Number(profile.id),
      groupLeaderId: 10,
      CenterId: selectCenterId,
      Status: formData.status === "Active" ? 1 : 0,
      MinMember: Number(formData.minMember),
      MaxMember: Number(formData.maxMember),
      Entryuser: "admin",
      superAdminId: profile.superAdminId,
    };

    try {
      if (editIndex === null) {
        // CREATE
        const res = await axios.post(
          "https://narrowitsolution.in/api/groupupdate/create",
          payload
        );
        toast.success(res.data?.message || "Group Added");
      } else {
        // UPDATE
        const id = groups[editIndex]?.id;
        const res = await axios.put(
          `https://narrowitsolution.in/api/groupupdate/${id}`,
          payload
        );
        toast.success(res.data?.message || "Group Updated");
      }

      fetchGroups();
      resetForm();
      setModalOpen(false);

    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to create/update");
    }
  };

  // handleDelete
  const handleDelete = async (id) => {
    if (!id) return toast.warn("Invalid ID");

    if (!window.confirm("Are you sure you want to delete this group?")) return;

    try {
      const res = await axios.delete(`https://narrowitsolution.in/api/groupupdate/${id}`);
      toast.success(res.data?.message || "Group deleted successfully");
      fetchGroups();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete group");
    }
  };

  /* ------------------------------------
      GET ALL GROUPS
  ------------------------------------ */
  const fetchGroups = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`https://narrowitsolution.in/api/groupupdate/getall?LoanofficerId=${profile.id}`);
      setGroups(res.data.data);
    } catch (error) {
      toast.error("Failed to load groups");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  // Fetch Center Data
  const fetchCenters = async () => {
    try {
      const res = await axios.get(`https://narrowitsolution.in/api/group/centre?LoanofficerId=${profile.id}`);
      setCenter(res.data.data);
      if (res.data.data.length > 0) {
        setSelectedCenterId(res.data.data[0].id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  
  /* ------------------------------------
      SEARCH + PAGINATION
  ------------------------------------ */
  const filteredData = useMemo(() => {
    return groups.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [groups, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <div className="group-container">
        <h1 className="group-heading">Group</h1>

        <div className="group-create-filter-section">
          <div className="group-create-section">
            <h1>Collection Group List</h1>

            <button
              className="add-btn"
              onClick={() => {
                resetForm();
                setModalOpen(true);
              }}
            >
              Add New
            </button>
          </div>

          <div className="group-report-filter-div">
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

            <div className="group-filter">
              <label>Show </label>
              <select
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                value={itemsPerPage}
              >
                {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select>
              <span> entries</span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="group-report-table-container">
          <table className="group-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Group Name</th>
                <th>Center Id</th>
                <th>Min Member</th>
                <th>Max Member</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{item.groupname}</td>
                    <td>{item.CenterId}</td>
                    <td>{item.MinMember}</td>
                    <td>{item.MaxMember}</td>
                    <td>{Number(item.Status) === 1 ? "Active" : "Inactive"}</td>

                    <td className="group-action-btns">
                      <Edit
                        className="edit-icon"
                        onClick={() => {
                          const globalIndex =
                            (currentPage - 1) * itemsPerPage + index;
                          setEditIndex(globalIndex);

                          setFormData({
                            groupName: item.groupname,
                            minMember: item.MinMember,
                            maxMember: item.MaxMember,
                            status:
                              Number(item.Status) === 1
                                ? "Active"
                                : "Inactive",
                          });

                          setSelectedCenterId(item.CenterId);

                          setModalOpen(true);
                        }}
                      />
                      <Trash
                        className="delete-icon"
                        onClick={() => handleDelete(item.id)}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  {loading ? (
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  ) : (
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="group-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}

        {/* Modal */}
        {modalOpen && (
          <div className="group-dialog-overlay">
            <div className="group-dialog-box">
              <h2 className="group-dialog-box-heading">
                {editIndex !== null ? "Edit Group" : "Add New Group"}
              </h2>

              <form
                className="group-dialog-box-form-section"
                onSubmit={handleSubmit}
              >
                <div className="group-dialog-box-form-grid">
                  

                  <div className="group-dialog-box-input-group">
                    <label>Select Center</label>
                    <select
                      name="centerId"
                      value={selectCenterId}
                      onChange={(e) =>
                        setSelectedCenterId(Number(e.target.value))
                      }
                    >
                      <option value=""></option>
                      {center.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.CenterName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Group Name</label>
                    <input
                      type="text"
                      name="groupName"
                      value={formData.groupName}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Min Member</label>
                    <input
                      type="number"
                      name="minMember"
                      value={formData.minMember}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Max Member</label>
                    <input
                      type="number"
                      name="maxMember"
                      value={formData.maxMember}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="group-dialog-box-input-group">
                    <label>Group Status</label>
                    <div>
                      <input
                        type="radio"
                        name="status"
                        value="Active"
                        checked={formData.status === "Active"}
                        onChange={handleChange}
                      />
                      ✔Active
                      <input
                        type="radio"
                        name="status"
                        value="Inactive"
                        style={{ marginLeft: "10px" }}
                        checked={formData.status === "Inactive"}
                        onChange={handleChange}
                      />
                      ❌Inactive
                    </div>
                  </div>
                </div>

                <div className="group-dialog-btns">
                  <button type="submit">
                    {editIndex !== null ? "Update" : "Create"}
                  </button>

                  <button type="button" onClick={() => setModalOpen(false)}>
                    Cancel
                  </button>

                  <button type="button" onClick={resetForm}>
                    Reset
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default GroupCreate;
